/**
 * AJAX mailchimp form submission.
 * 
 * @since 1.0.0
 * @author Fahri Rusliyadi <fahri.rusliyadi@gmail.com>
 */

"use strict";

import $ from 'jquery';
    
export default function() {
    $(document).on('submit', '.mc4wp-form', function(event) {
        let $form   = $(this);
        let action  = $form.attr('action') || location.href;
        let data    = $form.serialize();
        
        $form
            .find(':input')
            .filter(':not(.hidden)')
            .attr('disabled', 'disabled');
                
        $.post(action, data)
            .always(function(response) {
                if (typeof response !== 'string') {
                    response = response.responseText;
                }
                
                $(response)
                    .find(`#${$form.attr('id')}`)
                    .replaceAll($form);
            });
        
        event.preventDefault();
    });
};
